const script = () => {
  (function(){
    try {
      var SmartnewsAds = { 'id' : '14sghd', 'event' : '' };

      var script = document.createElement('script');
      script.src = '//api.smartnews-ads.com/assets/conv.js?' + (new Date()).getTime();
      script.type = 'text/javascript';
      script.id = '_smartnews_ads_conversion_script_' + SmartnewsAds['id'];
      script.setAttribute('data-smartnews-ads', JSON.stringify(SmartnewsAds));
      (document.body||document.head).appendChild(script);
    } catch (e) {}
  })();
};

export default {
  script,
};